<template>
  <v-dialog
    :value="show"
    max-width="520px"
    @input="cancel"
  >
    <v-card class="pa-sm-8 pa-4">
      <v-card-title class="text-h6 pa-0 mb-1">
        Проверка: {{ name }}
      </v-card-title>
      <v-card-subtitle class="pa-0 mb-6">
        Сохранённый текст с примерными значениями подстановок уйдёт на все устройства
        выбранного гостя.
      </v-card-subtitle>

      <v-card-text class="pa-0">
        <test-customer-select v-model="customerId"></test-customer-select>

        <v-alert
          v-if="result"
          :type="result.type"
          text
          dense
          class="mt-4 mb-0"
        >
          {{ result.text }}
        </v-alert>
      </v-card-text>

      <v-card-actions class="pa-0 mt-6">
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          outlined
          @click="cancel"
        >
          Закрыть
        </v-btn>
        <v-btn
          color="primary"
          :loading="sending"
          :disabled="!customerId"
          @click="send"
        >
          Отправить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { devicesText } from '@/helpers/notifications'
import TestCustomerSelect from '@/views/notification-settings/test-customer-select.vue'

export default {
  name: 'EventTestDialog',
  components: { TestCustomerSelect },

  props: {
    show: { type: Boolean, default: false },
    event: { type: Object, default: null },
    cancellation: { type: Function, required: true },
  },
  data: () => ({
    customerId: null,
    sending: false,

    result: null,
  }),
  computed: {
    name() {
      return this.event ? this.event.name : ''
    },
  },
  watch: {
    show(opened) {
      if (opened) this.result = null
    },
  },
  methods: {
    ...mapActions('notificationSettings', ['sendTestEvent']),
    cancel() {
      this.cancellation()
    },
    async send() {
      this.sending = true
      this.result = null

      try {
        const { devices } = await this.sendTestEvent({ code: this.event.code, customerId: this.customerId })
        this.result = { type: 'success', text: `Поставлено на ${devicesText(devices)}` }
      } catch (error) {
        this.result = {
          type: 'error',
          text: error.response?.data?.message || 'Не удалось отправить проверочный пуш',
        }
      } finally {
        this.sending = false
      }
    },
  },
}
</script>
